import { ethers } from "ethers";
import { EVM_CONFIG } from "../config";
import { privatePools } from "./privatePools";

export function assertPublicWithdrawalRecipient(recipient: string): void {
  const address = ethers.getAddress(recipient).toLowerCase();
  if (
    privatePools().some((pool) => pool.toLowerCase() === address) ||
    EVM_CONFIG.DERIVATION_VERIFIER?.toLowerCase() === address
  )
    throw new Error(
      "This is a pool or verifier address. Use a private address to send privately; a public transfer there cannot create a recoverable note.",
    );
}
